import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  ViewChild,
} from "@angular/core";
import { Observable, of } from "rxjs";
import { SurveyFrameTabTemplateComponent } from "src/app/core/survey/shared/survey-frame-list/survey-frame-tab-template/survey-frame-tab-template.component";
import { InsideSurvey } from "src/app/shared/Models/read";
import { INSIDE_SURVEY_CONTACT_INFO } from "../../../config/inside-survey.magic-strings";
import { InsideSurveyTab } from "../../../models/insideSurveyTab.interface";
import { ValidationError } from "../../../../../../shared/Models/ValidationError";
import { InsideSurveyContactInfoFormComponent } from "./info-form/inside-survey-contact-info-form.component";

@Component({
  selector: "app-inside-survey-contact-info",
  templateUrl: "./inside-survey-contact-info.component.html",
  styleUrls: ["./inside-survey-contact-info.component.scss"],
})
export class InsideSurveyContactInfoComponent
  implements InsideSurveyTab, OnInit, AfterViewInit
{
  @Input() isAuthCanWrite: boolean;
  @Input() survey: InsideSurvey;
  @ViewChild("contactForm") contactForm: InsideSurveyContactInfoFormComponent;
  @ViewChild("tabs") tabsComponent: SurveyFrameTabTemplateComponent;
  tabId: string = INSIDE_SURVEY_CONTACT_INFO;

  contexts: any[] = [];

  constructor() {}

  ngOnInit(): void {
    this.getContexts();
  }

  ngAfterViewInit(): void {
    this.tabsComponent?.onToggleDetail(this.survey?.buildings?.[0]?.id);
  }

  getContexts() {
    this.contexts =
      this.survey?.buildings?.map((b, i) => ({
        id: b.id,
        index: i,
        building: b,
      })) ?? [];
  }

  getValidationError(): ValidationError {
    return undefined;
  }

  onUpdateContact(contact) {
    for (let building of this.survey.buildings) {
      let i = building.persons.findIndex((p) => p.id == contact.id);
      if (i != -1) building.persons[i] = contact;
    }
    this.getContexts();
  }

  save(): Observable<boolean> {
    return this.contactForm?.save() ?? of(true);
  }
}
